//

import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Variwide from "highcharts/modules/variwide";

// Initialize the variwide module
Variwide(Highcharts);

const DrugProceduresChart = () => {
  const rawData = [
    ["COVID-19 Infusion Therapy", 1.45, 50.0],
    ["Contrast Agents/Diagnostic Imaging", 0.0, 100],
    ["Additional Miscellaneous Drugs", 5.41, 100],
    ["Chemotherapy Anti-emetic Medications", 39.78, 0.0],
    ["Miscellaneous Drugs and Tests", 0.0, 100],
    ["Skin Substitutes and Biologicals", 3.73, 100],
    ["Cancer, Vision and Other Associated Drugs", 4.88, 100],
    ["Other Drugs and Test", 10.58, 99.79],
  ];
  const colorPalette = [
    "#c0e7e7",
    "#507a8a",
    "#d1e8ff",
    "#ffd29f",
    "#f7bf9e",
    "#f7e6da",
    "#f4e7bb",
    "#c2e2ea",
    "#d7e3fc ",
  ];
  const [filter1, setFilter1] = useState("Option A");
  const [filter2, setFilter2] = useState("Option X");
  const [filter3, setFilter3] = useState("2024");

  const transformedData = rawData.map(([name, width, height]) => [
    name,
    height,
    width,
  ]);

  const options = {
    chart: {
      type: "variwide",
    },
    colors: colorPalette, // ← apply custom palette here
    title: {
      text: "%completeness and Medicare Weight",
    },
    subtitle: {
      text: "Variation with Original Data ",
    },
    xAxis: {
      type: "category",
      labels: {
        rotation: 0,
      },
    },
    caption: {
      text: "Column widths are proportional to value (Z)",
    },
    credits: { enabled: false },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Cost",
        data: transformedData,
        dataLabels: {
          enabled: true,
          format: "{point.y:.2f}",
        },
        tooltip: {
          pointFormat:
            "%_medicare: <b>{point.y}</b><br>Medicare Weight: <b>{point.z}</b>",
        },
        borderRadius: 3,
        colorByPoint: true,
      },
    ],
  };

  return (
    <div
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      <div
        style={{
          marginBottom: "1rem",
          display: "flex",
          gap: "1rem",
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "6px",
        }}
      >
        <div className="d-flex flex-column">
          <label className="form-label">Select Network:</label>
          <select
            value={filter1}
            onChange={(e) => setFilter1(e.target.value)}
            style={{
              width: "180px",
              backgroundColor: "white",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          >
            <option>Select Network</option>
          </select>
        </div>
        <div className="d-flex flex-column">
          <label className="form-label">Select Category:</label>
          <select
            value={filter2}
            onChange={(e) => setFilter2(e.target.value)}
            style={{
              width: "180px",
              backgroundColor: "white",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          >
            <option>Select Category</option>
          </select>
        </div>
        <div className="d-flex flex-column">
          <label className="form-label">Select Metrics:</label>
          <select
            value={filter3}
            onChange={(e) => setFilter3(e.target.value)}
            style={{
              width: "180px",
              backgroundColor: "white",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          >
            <option>Select Metrics</option>
          </select>
        </div>
      </div>

      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default DrugProceduresChart;
